import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Button, ButtonToolbar, Col, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import SpinerVeye from '../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../conexoes/api'
import { mudarManejador } from '../../redux/actions/index'
import { elipseVerde, setaDropdown } from '../../utils/alternanciaIcones'
import Historico from '../calendario/calendario'

import '../../css/clickstreamAnalise/css/style.css'
import ColetaClickstream from './clickstreamColeta.js'
import SelectLogin from './modais/selecLogin'
import SelectUrl from './modais/selectUrl'

export default function ClickstreamAnalise() {
  const { handleSubmit } = useForm()
  const [revelarSelectLogin, setRevelarSelectLogin] = useState(false)
  const [revelarSelectUrl, setRevelarSelectUrl] = useState(false)
  const [dsLogin, setDsLogin] = useState('Selecione')
  const [dsUrl, setDsUrl] = useState('Selecione')
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [vetorLogins, setVetorLogins] = useState([])
  const [vetorUrls, setVetorUrls] = useState([])
  const [dataInicio, setDataInicio] = useState()
  const [dataFinal, setDataFinal] = useState()

  const desativarBotao = true
  const dataMin = moment().subtract(30, 'days').toDate()
  const dataMax = new Date()
  const phUrl = 'Selecione'
  const phLogin = 'Selecione'

  const despacho = useDispatch()
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(151)
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    despacho(mudarManejador('clickstream'))

    setSpinAtivo(true)
    async function carregarVetorLogins() {
      const resultado = await api_gateway.get(
        '/m1/servicos/clickstream/consultarclickstream?opcao=' + 'email'
      )

      setVetorLogins(resultado.data.dados)
    }
    carregarVetorLogins()
    setSpinAtivo(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function carregarVetorUrls() {
      const resultado = await api_gateway.get(
        '/m1/servicos/clickstream/consultarclickstream?opcao=' +
          'url' +
          '&email=' +
          dsLogin
      )
      setVetorUrls(resultado.data.dados)
    }
    if (dsLogin != 'Selecione') {
      setDsUrl('Selecione')
      carregarVetorUrls()
    }
  }, [dsLogin])

  useEffect(() => {
    async function carregarVetorTempo() {
      const resultado = await api_gateway.get(
        '/m1/servicos/clickstream/consultarclickstream?opcao=' +
          'tempo' +
          '&email=' +
          dsLogin +
          '&url=' +
          dsUrl
      )
      setDataInicio(moment(resultado.data.dados[0])._d)
      setDataFinal(moment(resultado.data.dados[1])._d)
    }
    if (dsUrl != 'Selecione') {
      carregarVetorTempo()
    } else {
      setDataInicio()
      setDataFinal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dsUrl])

  async function handleImprimirClickstream() {
    if (dsLogin != 'Selecione' && dsUrl != 'Selecione') {
      const periodoInicio = new Date(dataInicio).getTime()
      const periodoFim = new Date(dataFinal).getTime()
      const dadosMapa = {
        email: dsLogin,
        url: dsUrl,
        dataInicio: periodoInicio < periodoFim ? periodoInicio : periodoFim,
        dataFinal: periodoFim >= periodoInicio ? periodoFim : periodoInicio
      }
      localStorage.setItem('dadosdeheatmap', JSON.stringify(dadosMapa))
      const url = dsUrl + '?data=heatmapPrint'
      window.open(url, '_blank')
    }
  }

  return (
    <Form onSubmit={handleSubmit(() => handleImprimirClickstream())}>
      <div className="modal-clickstream-analise fundo-cor-6">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Clickstream</div>
            </Form.Label>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Login</div>
              </Form.Label>
              {revelarSelectLogin === false && (
                <Button
                  name="cdLogin"
                  className="campo-texto-cor-3 label-elipses campo-select"
                  onClick={() => setRevelarSelectLogin(!revelarSelectLogin)}
                >
                  <div className="fonte-cor-1 label-campo">{dsLogin}</div>
                  <img
                    className="campo-select-icone-desativado nao-selecionavel"
                    src={setaDropdown()}
                    alt="drop"
                  />
                </Button>
              )}
              {revelarSelectLogin === true && (
                <SelectLogin
                  setRevelarSelectLogin={setRevelarSelectLogin}
                  setDsLogin={setDsLogin}
                  vetorLogins={vetorLogins}
                  setSpinAtivo={setSpinAtivo}
                  phLogin={phLogin}
                  dsLogin={dsLogin}
                />
              )}
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Url</div>
              </Form.Label>
              {revelarSelectUrl === false && (
                <Button
                  name="cdUrl"
                  className="campo-texto-cor-3 label-elipses campo-select"
                  onClick={() => setRevelarSelectUrl(!revelarSelectUrl)}
                >
                  <div className="fonte-cor-1 label-campo">{dsUrl}</div>
                  <img
                    className="campo-select-icone-desativado nao-selecionavel"
                    src={setaDropdown()}
                    alt="drop"
                  />
                </Button>
              )}
              {revelarSelectUrl === true && (
                <SelectUrl
                  setRevelarSelectUrl={setRevelarSelectUrl}
                  vetorUrls={vetorUrls}
                  setSpinAtivo={setSpinAtivo}
                  setDsUrl={setDsUrl}
                  phUrl={phUrl}
                  dsUrl={dsUrl}
                />
              )}
            </Form.Group>
          </Col>
        </Form.Row>

        <>
          <div className="container-calendario-detalhemento-linha">
            <Historico
              imputCustomisado="De:"
              data={dataInicio}
              setData={setDataInicio}
              dataMax={dataMax}
              dataMin={dataMin}
            />
          </div>
          <div className="container-calendario-detalhemento-linha">
            <Historico
              imputCustomisado="Até:"
              data={dataFinal}
              setData={setDataFinal}
              dataMax={dataMax}
              dataMin={dataMin}
            />
          </div>
        </>

        <ButtonToolbar className="bt-barra-clickstream">
          <Button
            disable={desativarBotao}
            type="submit"
            className="botao-confirmar botao-confirmar-clickstream"
            variant="success"
            size="sm"
          >
            <div className="bg-color">Imprimir Clickstream</div>
          </Button>
        </ButtonToolbar>

        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
      </div>
    </Form>
  )
}
